import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { throttle } from 'lodash'

import AutoBookingPopover from './AutoBookingPopover'
import BookingConfirmModal from './BookingConfirmModal'
import DeleteConfirmation from './DeleteConfirmation'
import {
  disableSubmitButton,
  validCustomTime,
} from '../helpers'

class AutoBookingPopoverContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showBookingConfirm: false,
      showDeleteConfirmation: false,
      showSpinner: false,
    }
  }

  componentDidMount() {
    this.props.leaveModalOpen()
  }

  findDoctorName = () => {
    const { doctors, doctor } = this.props
    const selectDoc = doctors.find(doc => doc.id === doctor)
    return selectDoc ? selectDoc.preferred_name : false
  }

  onDeleteConfirm = () => {
    const { showDeleteConfirmation } = this.state
    this.setState({ showDeleteConfirmation: !showDeleteConfirmation })
  }

  onSubmit = () => throttle(() => {
    this.setState({ showSpinner: true })
    this.props.onSaveClick()
  }, 2000)

  findLocationName = () => {
    const { locations, location } = this.props
    const selectedLoc = locations.find(loc => loc.id === location)
    return selectedLoc ? selectedLoc.name : false
  }

  patientFullName = () => {
    const { patient } = this.props
    return `${patient.first_name} ${patient.last_name}`
  }

  render() {
    const {
      appointmentTime,
      appointmentTimes,
      autoAptTime,
      onClose,
      onDeleteClick,
      showBookingConfirm,
      startDateTime,
    } = this.props
    const submitDisabled = disableSubmitButton(autoAptTime)
    const timeDropdownValue = validCustomTime(appointmentTimes, autoAptTime)
      ? 'Custom'
      : autoAptTime || '- select -'

    if (this.state.showDeleteConfirmation) {
      return (
        <DeleteConfirmation
          mainMessage={'Are you sure you want to delete this booking?'}
          onDeleteClick={onDeleteClick}
          onDeleteConfirm={this.onDeleteConfirm}
          secondaryMessage={
            'deleting this reservation will notify the patient and request that they call to reschedule'
          }
        />
      )
    }

    if (showBookingConfirm) {
      return (
        <BookingConfirmModal
          appointmentTime={appointmentTime}
          date={startDateTime}
          doctorName={this.findDoctorName()}
          locationName={this.findLocationName()}
          onClose={onClose}
          patientFullName={this.patientFullName}
        />
      )
    }
    return (
      <AutoBookingPopover
        {...this.props}
        locationName={this.findLocationName()}
        onSubmit={this.onSubmit}
        patientFullName={this.patientFullName}
        onDeleteConfirm={this.onDeleteConfirm}
        showSpinner={this.state.showSpinner}
        submitDisabled={submitDisabled}
        timeDropdownValue={timeDropdownValue}
      />
    )
  }
}

AutoBookingPopoverContainer.propTypes = {
  appointmentTime: PropTypes.string,
  appointmentTimes: PropTypes.array, // arrayOf moment instance and string
  autoAptTime: PropTypes.string,
  doctor: PropTypes.string,
  doctors: PropTypes.arrayOf(PropTypes.object),
  handleValueUpdate: PropTypes.func.isRequired,
  leaveModalOpen: PropTypes.func.isRequired,
  location: PropTypes.string,
  locations: PropTypes.arrayOf(PropTypes.object),
  onClose: PropTypes.func.isRequired,
  onDeleteClick: PropTypes.func.isRequired,
  onSaveClick: PropTypes.func.isRequired,
  showBookingConfirm: PropTypes.bool,
  startDateTime: PropTypes.string.isRequired,
}

export default AutoBookingPopoverContainer



// WEBPACK FOOTER //
// ./src/components/OnlineScheduling/BookingsCalendar/BookingPopover/AutoBookingPopover/index.js